const hostname = window.location.hostname;

console.log('hostname +++++++++++++++++ ');
console.log(hostname);

const backendUrl =
    hostname === 'platform.aurora-mbc.org'
        ? 'https://platform.aurora-mbc.org'
        : hostname === 'training.aurora-mbc.org'
          ? 'https://training.aurora-mbc.org'
          : hostname === 'platform-v2-demo.aurora-mbc.org'
            ? 'https://platform-v2-demo.aurora-mbc.org'
            : hostname === 'aurora-ctc.hubruxelles.be'
              ? 'https://aurora-ctc.hubruxelles.be'
              : hostname === 'stg-aurora-ctc.hubruxelles.be'
                ? 'https://stg-aurora-ctc.hubruxelles.be'
                : hostname === 'training-aurora-ctc.hubruxelles.be'
                  ? 'https://training-aurora-ctc.hubruxelles.be'
                  : hostname === 'wslhost'
                    ? `http://wslhost:9950`
                    : hostname === 'dckdmp8.res.hub.internal'
                      ? `http://dckdmp8.res.hub.internal:9950`
                      : `http://${hostname}:899`;

console.log('backendUrl : ', backendUrl);
// In development (localhost), use relative URL to leverage CRA proxy
// In production, use the full backend URL
const graphqlUri =
    hostname === 'localhost' ? '/graphql' : `${backendUrl}/graphql`;

// these will be included in the forms but hidden from the user. they're
// used for legacy reasons.
export const HIDDEN_ATTRIBUTES = [
    'icf_1_0_signed',
    'icf_1_1_signed',
    'icf_2_0_signed',
    'icf_3_0_signed',
    'icf_4_0_signed',
];

export const Settings = {
    MEDIA_URL: hostname === 'localhost' ? '/media/' : `${backendUrl}/media/`,
    ACCESS_TOKEN: 'aurora.accessToken',
    GRAPHQL_URI: graphqlUri,
    // LOGIN_URL: `${backendUrl}/accounts/google/login/`,
    HOME_PAGE: '/patients',
    BACKEND_URL: hostname === 'localhost' ? '' : backendUrl,
};
